import "./Fridge.css"
import Product1 from "./Product1"
import Wm1 from "../images/wm1.jpg"
import Wm2 from "../images/wm2.jpg"
import Wm3 from "../images/wm3.jpg"
import Wm4 from "../images/wm4.jpg"
import Wm5 from "../images/wm5.jpg"
import Wm6 from "../images/wm6.jpg"
import Wm7 from "../images/wm7.jpg"
import Wm8 from "../images/wm8.jpg"
import Wm9 from "../images/wmadd.jpg"




export default function Fridge() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Wm9} /></div>
          
                   

      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="washing1"prdName="LG" img={Wm1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1  id="washing2"prdName="HAIER" img={Wm2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="washing3" prdName="BLUESTAR" img={Wm3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="washing4" prdName="SAMSUNG" img={Wm4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="washing5" prdName="ONIDA" img={Wm5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="washing6" prdName="HAIER3" img={Wm6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="washing7" prdName="BLUSTAR" img={Wm7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="washing8"prdName="WHIRLPOOL" img={Wm8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}